import React from 'react';
import { Link } from 'react-router-dom';

const hrefPatterns = {
    "vob": "/sponsor/connectToVOB/{id}",
}

const types = {
    "vob": "Company",
}

class SponsorResult extends React.Component {

    render() {
        const r = this.props.result;

        try {
            const href = hrefPatterns[r.type].replace("{id}", r.id).replace("{parentId}", r.parentId);
            const type = types[r.type];

            return (
                <React.Fragment>
                    <div className="search-result">
                        <Link className="search-link" to={href}>{r.title}</Link><br />
                        <span className="search-type">{type}</span><br />
                        <span className="search-summary" dangerouslySetInnerHTML={{ __html: r.summary }} />
                    </div>
                </React.Fragment>
            )
        }
        catch (e) {
            return null;
        }
    }
}

export default SponsorResult;



// WEBPACK FOOTER //
// ./src/areas/main/search/SponsorResult.js